import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';
import Footer from './components/Footer';
import Header from './components/Header';
import { debounce, generateRandomBorder, randomInRange } from './utils/helpers';
import ScrollReveal from './animations/ScrollReveal';
import LazyVideo from './components/LazyVideo';
import GeneralBlocks from './components/GeneralBlocks';
import Menu from './components/Menu';
import LocationSearch from './components/LocationSearch';
import GoogleMap from './components/GoogleMap';
import Announcement from './components/Announcement';
import Feed from './components/Feed';

class Website {
  constructor() {
    this.wWidth = $(window).width();
    this.$body = $('body');

    this.footer = new Footer(this.wWidth);
    this.initUniqueShapes($('.btn, .media--rounded, .blob-shape'));
    this.menu = new Menu(this.wWidth);
    this.generalBlocks = new GeneralBlocks(this.wWidth);
    this.locationSearch = new LocationSearch('.find .search');
    this.restaurantMap = $('.restaurant-info__map').map(
      (i, el) => new GoogleMap(el)
    );
    this.map = $('.map__map').map((i, el) => new GoogleMap(el, this.wWidth));

    this.header = new Header(this.wWidth);

    this.initTriggeredAnnouncements();
    this.initScrollingLinks();
    this.initObservers();
    this.addEventListeners();

    this.initForms();
    this.announcement = $('.announcement-default').map((i, el) => {
      return new Announcement(el, this.wWidth);
    });
    this.feeds = $('.feed').map((i, el) => {
      return new Feed(el, this.initUniqueShapes);
    });

    if (!window.location.pathname.includes('/5hh')) {
      setTimeout(() => {
        this.initNewsletterModal();
      }, 7000);
    }

    if ($('.future-form').length > 0) {
      $('.future-form .form-group--privacy').before(
        '<div class="form-group form-group--checkbox form-group--bicycle">' +
          '  <input type="checkbox" id="BicyclePrivacyPolicy" name="BicyclePrivacyPolicy">' +
          '  <label for="BicyclePrivacyPolicy">' +
          'Click here to receive emails about news, offers and prizes from Bicycle Partnerships Ltd <br /> <a href="https://culturecycle.co.uk/privacy-policy/" target="_blank">Privacy Policy</a>' +
          '  </label>\n' +
          '</div>\n' +
          '<div class="form-group form-group--checkbox form-group--musical">\n' +
          '  <input type="checkbox" id="MusicalPrivacyPolicy" name="MusicalPrivacyPolicy">\n' +
          '  <label for="MusicalPrivacyPolicy">' +
          'Click here to receive emails about news and offers from Back to the Future the Musical <br /> <a href="https://www.backtothefuturemusical.com/london/privacy-policy/" target="_blank">London Privacy Policy</a>' +
          '  </label>' +
          '</div>'
      );
    }

    if ($('.masterclass-form').length > 0) {
      $('.masterclass-form .form-group--FirstName').before(
        '<h3 class="form-group" style="font-size: 16px;">Type of Masterclass</h3>' +
          '<div class="form-group form-group--checkbox form-group--bicycle">' +
          '  <input type="radio" id="Kids" name="TypeOfMasterclass" value="Kids">' +
          '  <label for="Kids">Kids</label>\n' +
          '</div>\n' +
          '<div class="form-group form-group--checkbox form-group--musical">\n' +
          '  <input type="radio" id="Adults" name="TypeOfMasterclass" value="Adults">\n' +
          '  <label for="Adults">Adults</label>' +
          '</div>'
      );
    }

    $('.form-group--checkbox input').on('change', function () {
      $(this).toggleClass('active-checkbox');
    });
  }

  initNewsletterModal() {
    // Check if the modal has been closed during this session
    if (!localStorage.getItem('newsletterModalClosed')) {
      $('.newsletter-overlay').show();
      $('.newsletter-modal').show();
    }

    // Close modal on overlay click
    $('.newsletter-overlay').on('click', () => {
      this.closeNewsletterModal();
    });

    // Close modal on close button click
    $('.newsletter-modal__close').on('click', () => {
      this.closeNewsletterModal();
    });
  }

  closeNewsletterModal() {
    $('.newsletter-overlay').hide();
    $('.newsletter-modal').hide();
    localStorage.setItem('newsletterModalClosed', 'true');
  }

  initUniqueShapes($targets) {
    this.$blobElements = $targets.each((i, el) => {
      const $el = $(el);
      const isBtn = $el.hasClass('btn');
      const isMedia = $el.hasClass('media--rounded');
      let borderValues = [15, 25, 20, 30];
      let borderType = 'percent';
      let rotationValues = [-3, 3];

      const dataBorder = $el.data('border');
      const dataType = $el.data('border-type');
      const dataRotation = $el.data('rotation');

      if (isBtn) {
        borderValues = [30, 60, 25, 35];
        borderType = 'pixels';
      }

      if (dataBorder) {
        borderValues = dataBorder.split(',');
        borderValues = borderValues.map((val) => parseInt(val, 10));
      }
      if (dataType) borderType = dataType;
      if (dataRotation) {
        rotationValues = dataRotation.split(',');
        rotationValues = rotationValues.map((val) => parseInt(val, 10));
      }

      const borderRadius = generateRandomBorder(...borderValues, borderType);
      $el.css({ 'border-radius': `${borderRadius}` });

      if (isMedia && !$el.hasClass('media--no-rotation')) {
        const rotation = randomInRange(...rotationValues);
        $el.css({ transform: `rotate(${rotation}deg)` });
      }
    });
  }

  initScrollingLinks() {
    this.$links = $('a');

    this.$links.on('click', (e) => {
      const $cur = $(e.currentTarget);
      const href = $cur.attr('href');
      const hrefArr = href.split('#');
      const { pathname, origin } = window.location;

      if (
        !href ||
        href === '#' ||
        (!href.startsWith('#') && !href.includes('#')) ||
        (!href.startsWith('#') &&
          hrefArr[0] !== pathname &&
          hrefArr[0] !== origin + pathname)
      ) {
        return;
      }

      const $target = href.startsWith('#') ? $(href) : $(`#${hrefArr[1]}`);
      if ($target.length) {
        e.preventDefault();

        const offset = $target.offset().top;

        $('html, body').animate(
          {
            scrollTop: offset - 150,
          },
          600
        );

        window.history.pushState(null, null, href);
      }
    });

    if (window.location.hash) {
      const $target = $(window.location.hash);

      if ($target.length) {
        const offset = $target.offset().top;

        window.scrollTo(0, 0);

        setTimeout(() => {
          $('html, body').animate(
            {
              scrollTop: offset - 150,
            },
            600
          );
        }, 500);
      }
    }
  }

  initForms() {
    this.dateInputs = $('.form-control--date').map((i, el) => {
      const isDateTime = $(el).hasClass('form-control--DateTime');
      const isBirthDate = $(el).hasClass('form-control--BirthDate');
      const source = $(el).parent().siblings('input[id^="acteol-form-source"]');
      const isChristmas = source.val() === '154';

      const options = {
        locale: localeEn,
        dateFormat: 'yyyy/MM/dd',
        autoClose: true,
      };

      if (isBirthDate) {
        const startDate = new Date();
        startDate.setFullYear(startDate.getFullYear() - 23);

        options.startDate = startDate;
        options.maxDate = new Date();
      }

      if (isDateTime) {
        const now = new Date();
        now.setDate(now.getDate() + 1);
        now.setHours(0, 0, 0, 0);

        options.timepicker = true;
        options.minDate = now;
        options.minutesStep = 10;
        options.timeFormat = 'hh:mm aa';
      }

      if (isChristmas) {
        const minDate = new Date();
        minDate.setMonth(10);
        minDate.setDate(14);
        minDate.setHours(0, 0, 0, 0);
        const maxDate = new Date();
        maxDate.setMonth(11);
        maxDate.setDate(24);
        maxDate.setHours(23, 59, 59, 999);
        options.startDate = minDate;
        options.minDate = minDate;
        options.maxDate = maxDate;

        options.onBeforeSelect = ({ date }) => {
          if (date < minDate || date > maxDate) {
            return false;
          }
          return true;
        };
      }

      const $wrapper = $(el).closest('.acteol-block-form');
      console.log($wrapper);

      if (
        $wrapper.length &&
        $wrapper.parent().hasClass('announcement-shortcode-wrapper')
      ) {
        return;
      }

      return new AirDatepicker(el, options);
    });

    this.$formBlobInputs = $('.form-control').each((i, el) => {
      const $el = $(el);
      const borderValues = [25, 35, 25, 30];
      const borderType = 'pixels';

      const borderRadius = generateRandomBorder(...borderValues, borderType);
      $el.css({ 'border-radius': `${borderRadius}` });
    });

    const targets = document.querySelectorAll(
      '.acteol-block-form[data-id="33"], .newsletter-modal'
    );

    targets.forEach((target) => {
      const firstSelect = target.querySelector('select');
      if (firstSelect && firstSelect.options.length > 0) {
        firstSelect.options[0].textContent = 'Favourite Pizzeria';
        firstSelect.options[0].value = 'favourite-pizzeria';
      }
    });

    const newsletterSurveyForms = document.querySelectorAll(
      '.acteol-block-form[data-id="33"]'
    );

    newsletterSurveyForms.forEach((form) => {
      const optInCheckbox = form.querySelector('input[name="MarketingOptin"]');
      const optInWrapper = form.querySelector('.form-group--MarketingOptin');

      if (optInCheckbox) {
        optInCheckbox.checked = true;
      }

      if (optInWrapper) {
        optInWrapper.style.display = 'none';
      }
    });
  }

  initObservers() {
    this.scrollReveal = new ScrollReveal(
      $(
        '.js-visibility:not(.is-visible), .js-visibility-inside>*:not(.is-visible)'
      )
    );
    this.lazyVideos = new LazyVideo();
  }

  addEventListeners() {
    $(document).on('click', this.onClick.bind(this));
    $(document).on('mousedown', this.onMouseDown.bind(this));
    $(document).on('keydown', this.onkeyDown.bind(this));

    const debouncedResize = debounce(this.onResize.bind(this), 500);
    $(window).on('resize', debouncedResize);
  }

  onClick() {
    this.header.onClick();
  }

  onMouseDown() {
    this.$body.removeClass('is-tab');
  }

  onkeyDown(event) {
    if (event.key === 'Tab') {
      this.$body.addClass('is-tab');
    }
  }

  initTriggeredAnnouncements() {
    const triggers = document.querySelectorAll('.announcement-trigger');

    if (!triggers.length) return;

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const trigger = entry.target;
            const id = trigger.dataset.announcementId;
            const targetAnnouncement = document.querySelector(
              `.announcement--triggered[data-announcement-id="${id}"]`
            );

            if (targetAnnouncement) {
              targetAnnouncement.classList.add('visible');

              const dateInputs = targetAnnouncement.querySelectorAll(
                '.form-control--date'
              );

              dateInputs.forEach((el) => {
                const isDateTime = el.classList.contains(
                  'form-control--DateTime'
                );
                new AirDatepicker(el, {
                  locale: localeEn,
                  dateFormat: 'yyyy/MM/dd',
                  autoClose: true,
                  position: 'top left',
                  timepicker: isDateTime,
                  container: document.body,
                });
              });
            }

            obs.unobserve(trigger);
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    triggers.forEach((trigger) => observer.observe(trigger));
  }

  onResize() {
    const width = $(window).width();

    if (this.wWidth !== width) {
      this.wWidth = width;

      this.header.onResize(this.wWidth);
      this.footer.onResize(this.wWidth);
      if (this.generalBlocks.onResize) {
        this.generalBlocks.onResize(this.wWidth);
      }
      if (this.announcement.onResize) {
        this.announcement.onResize(this.wWidth);
      }
    }
  }
}

$(document).ready(() => {
  new Website();
});
